import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useParams } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";
// bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

// pages & components
import LoginForm from "./components/PageComponents/LoginForm/LoginForm";
import AdminDashboardPage from "./pages/AdminDashboardPage/AdminDashboardPage";
import FirstInputPage from "./pages/FirstInputPage/FirstInputPage";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound/NotFound";
import SecondInputPage from "./pages/SecondInputPage/SecondInputPage";

function SecondInputWrapper() {
  const { id } = useParams();
  return <SecondInputPage documentId={id} />;
}

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isModerator, setIsModerator] = useState(false);
  const { user } = useAuthContext();

  useEffect(() => {
    setLoggedIn(Boolean(user?.token));
    setIsAdmin(user?.isAdmin);
    setIsModerator(user?.isModerator);
  }, [user]);

  return (
    <div className="App">
      <BrowserRouter>
        <div className="pages">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/FirstInput"
              element={loggedIn ? <FirstInputPage /> : <NotFound />}
            />
            <Route
              path="/SecondInput/:id"
              element={loggedIn ? <SecondInputWrapper /> : <LoginForm />}
            />
            <Route
              path="/AdminDashboard"
              element={
                loggedIn && (isAdmin || isModerator) ? (
                  <AdminDashboardPage />
                ) : (
                  <NotFound />
                )
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
